import React, { useState, useEffect, useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useToasts } from "react-toast-notifications";
import { useTeamContext } from "store/contexts/teamContext";
import CourseService from "services/CourseService";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import GrowthPartnerCourseLists from "components/CourseBuilder/GrowthPartnerCourseLists/GrowthPartnerCourseLists";

const GrowthPartnerCourses = () => {
  const { team } = useTeamContext();
  const { addToast } = useToasts();
  const [courses, setCourses] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const fetchGrowthPartnerCourses = useCallback((pageNum = 1) => {
    if (!team?.id) return;
    
    setIsLoading(true);
    
    if (pageNum === 1) {
      setCourses([]);
    }
    
    CourseService.getGrowthPartnerCourses(pageNum, 10, team.id)
      .then(response => {
        if (response && response.data) {
          if (pageNum === 1) {
            setCourses(response.data.data || []);
          } else {
            setCourses(prevCourses => [...prevCourses, ...(response.data.data || [])]);
          }
          setTotal(response.data.meta?.total || 0);
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Error fetching growth partner courses:", error);
        addToast("Failed to load growth partner courses", { appearance: "error" });
        setIsLoading(false);
      });
  }, [team?.id, addToast]);

  useEffect(() => {
    if (team?.id) {
      fetchGrowthPartnerCourses(1);
    }
  }, [team?.id, fetchGrowthPartnerCourses]);

  const getNextPageData = () => {
    const nextPage = page + 1;
    fetchGrowthPartnerCourses(nextPage);
    setPage(nextPage);
  };

  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  if (isLoading && page === 1) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Loader />
      </div>
    );
  }

  return (
    <div className="growth-partner-courses-container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3 tasks-btn">
        <h3 className="mb-0">Growth Partner Courses</h3>
      </div>

      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={total ?? 0}
        next={getNextPageData}
        hasMore={courses.length !== total}
        loader={LoadingContainer}
        scrollableTarget="main-panel-right"
        endMessage={
          <div style={{ textAlign: "center" }}>
            {total > 0 && <div>Yay! You have seen all your growth partner courses</div>}
          </div>
        }
      >
        {courses.length === 0 ? (
          <div style={{ 
            display: "flex",
            width: "100%",
            justifyContent: "center",
            padding: "100px 0",
            fontSize: "22px",
            fontWeight: "500"
          }}>You haven't been assigned as a growth partner for any courses yet</div>
        ) : (
          <GrowthPartnerCourseLists courses={courses} total={total} />
        )}
      </InfiniteScroll>
    </div>
  );
};

export default GrowthPartnerCourses; 